/**
 * Derives a error message from the API response when the operation is unsuccessful.
 * @param {Array} results - The value of the results field in the API response.
 * @returns {string} - The derived error message.
 */
export const deriveResultMessage = (results = []) => {
  const fallbackMessage = "Unknown results";
  // guard - if results is not an array or is empty
  if (!Array.isArray(results) || results.length === 0) {
    return fallbackMessage;
  }
  return results
    .reduce((acc, result) => {
      return [...acc, result.message || fallbackMessage];
    }, [])
    .join("\n");
};
